import React from 'react';
import LadingPage from '../LandingPage';
import EditRateTable from './EditRateTable';
import ViewRateTable from './ViewRateTable';

function RateTable() {
  return (
    <>
      <LadingPage>
        <div className="dash-board">
          <ViewRateTable />
        </div>
        <div className="mt-2">
          <EditRateTable />
        </div>
      </LadingPage>
    </>
  );
}

export default RateTable;
